import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { registerAppToastHandler } from "../../utils/appToastBus";

const DEFAULT_LIFE = 4500;
const MOBILE_MAX = 576;

/**
 * Single app-wide PrimeReact Toast; use showAppToast() from anywhere.
 * Mobile: top-center and full-width for readability; desktop: top-right.
 */
export default function AppToastProvider({ children }) {
  const toast = useRef(null);
  const [narrow, setNarrow] = useState(
    typeof window !== "undefined" ? window.innerWidth <= MOBILE_MAX : false
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);
    const onChange = () => setNarrow(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    registerAppToastHandler((options) => {
      if (!toast.current) return;
      toast.current.show({
        life: DEFAULT_LIFE,
        ...options,
      });
    });
    return () => registerAppToastHandler(null);
  }, []);

  return (
    <>
      <Toast
        ref={toast}
        position={narrow ? "top-center" : "top-right"}
        className="app-toast-stack"
        style={narrow ? { width: "min(100vw - 1rem, 24rem)", maxWidth: "100%" } : undefined}
      />
      {children}
    </>
  );
}
